export const formatFilesize = (size?: number) => {
  if (!size) {
    return "0 B";
  } else if (size > 0 && size < 1000) {
    return `${size} B`;
  } else if (size >= 1000 && size < 1000000) {
    return `${Math.trunc(size / 1000)}.${Math.trunc((size % 1000) / 10)} KB`;
  } else if (size >= 1000000 && size < 1000000000) {
    return `${Math.trunc(size / 1000000)}.${Math.trunc((size % 1000000) / 10000)} MB`;
  }
};
